export default __webpack_public_path__ + "static/14-fecb0c2f88039a7226086f1dd25755da.jpg";